import { createApp, h } from 'vue';
import DrugDetailDialog from './DrugDetailDialog.vue';

export function mountDrugDetailApp(elementId) {
  document.addEventListener('DOMContentLoaded', () => {
    const app = document.getElementById(elementId);
    if (!app) return;

    // slot に Rails の render 関数が入っていると、Vue の mount で既存 DOM が置き換えられて消えてしまう。
    // そのため mount 前に innerHTML を取得し、default slot に差し戻してサーバー描画された内容を引き継ぐ。
    const slotHtml = app.innerHTML;
    createApp({
      render() {
        return h(DrugDetailDialog, null, {
          default: () => h('div', { innerHTML: slotHtml }),
        });
      },
    }).mount(`#${elementId}`);
  });
}
